import { RestResource } from "./common"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export enum COMMUNICATION_GROUP {
  /** @deprecated */
  ACCOUNT = "Account Communications",
  /** @deprecated */
  TRADE = "Trade Communications",
  /** @deprecated */
  MARKETING = "Marketing Communications",
  /** @deprecated */
  REFERRAL = "Referral Communications",
  /** @deprecated */
  CASH = "Cash Communications",
  /** @deprecated */
  ORDER_FILL_NOTIFICATIONS = "Order Fill Notifications",

  // Reworked Communication Groups
  SECURITY = "Security",
  ACCOUNT_MANAGEMENT = "Account Management",
  ANNOUNCEMENTS = "Announcements",
  MARKET_NEWS = "Market News",
  PROMOTIONS = "Promotions",
  EDUCATION = "Education",
  FEEDBACK = "Feedback",
  MARGIN_AND_RISK = "Margin & Risk",
  ORDER_FILLS = "Order Fills",
  POSITION_ALERTS = "Position Alerts",
  PRICE_ALERTS = "Price Alerts",
  // only used for initialization
  BLANK = "",
}

export const REWORKED_COMMUNICATION_GROUPS: COMMUNICATION_GROUP[] = [
  COMMUNICATION_GROUP.SECURITY,
  COMMUNICATION_GROUP.ACCOUNT_MANAGEMENT,
  COMMUNICATION_GROUP.ANNOUNCEMENTS,
  COMMUNICATION_GROUP.MARKET_NEWS,
  COMMUNICATION_GROUP.PROMOTIONS,
  COMMUNICATION_GROUP.EDUCATION,
  COMMUNICATION_GROUP.FEEDBACK,
  COMMUNICATION_GROUP.MARGIN_AND_RISK,
  COMMUNICATION_GROUP.POSITION_ALERTS,
  COMMUNICATION_GROUP.ORDER_FILLS,
  COMMUNICATION_GROUP.PRICE_ALERTS,
]

export type CommunicationGroupPreferenceType =
  | "email"
  | "pushNotification"
  | "sms"

export class CommunicationGroupPreference extends RestResource {
  communicationGroupName: COMMUNICATION_GROUP = COMMUNICATION_GROUP.BLANK
  email = false
  externallyVisible = true
  /**
   * @field optional implies that the preference cannot be modified.
   * when optional is true it means the user should be allowed to modify this communication group.
   * when optional is false it means we must send these communications and the user may not change this.
   *
   **/
  optional = true
  pushNotification = false
  sms = false

  /** @deprecated */
  get isSmsVisible() {
    return this.communicationGroupName === COMMUNICATION_GROUP.MARKETING
  }
}

export const COMM_PREFERENCE_DESER: SchemaDeSer<CommunicationGroupPreference> =
  new SchemaDeSerBuilder(CommunicationGroupPreference)
    .ofString("id")
    .ofString("communicationGroupName")
    .ofBoolean("email")
    .ofBoolean("externallyVisible")
    .ofBoolean("optional")
    .ofBoolean("pushNotification")
    .ofBoolean("sms")
    .toDeSer()

export const COMM_PREFERENCE_PARSER = COMM_PREFERENCE_DESER.toParser(
  CommunicationGroupPreference
)
